import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
};

// Generation APIs
export const generateAPI = {
  generateText: (data) => api.post('/generate/text', data),
  generateImage: (data) => api.post('/generate/image', data),
  getHistory: (limit = 50) => api.get(`/generate/history?limit=${limit}`),
};

// Modules APIs
export const modulesAPI = {
  cybersecurityScan: (data) => api.post('/modules/cybersecurity/scan', data),
  accountingProcess: (data) => api.post('/modules/accounting/process', data),
  legalProcess: (data) => api.post('/modules/legal/process', data),
};

// Plans APIs
export const plansAPI = {
  getAllPlans: () => api.get('/plans/all'),
  getCurrentPlan: () => api.get('/plans/current'),
  purchasePlan: (planName) => api.post(`/plans/purchase/${planName}`),
  purchaseCredits: (amount) => api.post('/plans/credits/purchase', { amount }),
  getCreditHistory: (limit = 50) => api.get(`/plans/credits/history?limit=${limit}`),
};

// Invitation Codes APIs
export const invitationsAPI = {
  generateCodes: (data) => api.post('/invitations/generate', data),
  listCodes: () => api.get('/invitations/list'),
  validateCode: (code) => api.post(`/invitations/validate/${code}`),
  applyCode: (code) => api.post(`/invitations/apply/${code}`),
};


export default api;